import React from "react";
import { Link } from "react-router-dom";
import logo from "../imgs/logo.png";

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      {/* Navigation Header */}
      <div className="legal-nav">
        <div className="legal-nav-container">
          <Link to="/" className="back-button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
            Back
          </Link>

          <div className="legal-nav-brand">
            <img src={logo} alt="Viralz Logo" className="legal-nav-logo" />
            <span className="legal-nav-title">Viralz</span>
          </div>
        </div>
      </div>

      <div className="legal-container">
        <h1>Cookie Policy</h1>
        <div className="legal-meta">
          <p>
            <strong>Effective Date:</strong> January 1, 2025
          </p>
          <p>
            <strong>Last Updated:</strong> January 1, 2025
          </p>
        </div>

        <section>
          <h2>1. WHAT ARE COOKIES</h2>
          <p>
            Cookies are small text files that are placed on your device when you
            visit our website or use our mobile application. They help us
            provide you with a better experience by remembering your preferences
            and understanding how you use our Service.
          </p>
        </section>

        <section>
          <h2>2. TYPES OF COOKIES WE USE</h2>

          <h3>2.1 Essential Cookies</h3>
          <ul>
            <li>
              <strong>Authentication:</strong> Keep you logged in to your
              account
            </li>
            <li>
              <strong>Security:</strong> Protect against fraudulent activity
            </li>
            <li>
              <strong>Functionality:</strong> Remember your preferences and
              settings
            </li>
          </ul>

          <h3>2.2 Analytics Cookies</h3>
          <ul>
            <li>
              <strong>Usage Analytics:</strong> Understand how you interact with
              our Service
            </li>
            <li>
              <strong>Performance Monitoring:</strong> Track app performance and
              errors
            </li>
            <li>
              <strong>Feature Usage:</strong> Analyze which features are most
              popular
            </li>
          </ul>

          <h3>2.3 Third-Party Cookies</h3>
          <ul>
            <li>
              <strong>PostHog:</strong> User behavior analytics
            </li>
            <li>
              <strong>Mixpanel:</strong> Event tracking and user journey
              analysis
            </li>
            <li>
              <strong>Amplitude:</strong> Product analytics and user engagement
            </li>
            <li>
              <strong>Sentry:</strong> Error tracking and performance monitoring
            </li>
            <li>
              <strong>Superwall:</strong> Subscription and paywall analytics
            </li>
          </ul>
        </section>

        <section>
          <h2>3. HOW WE USE COOKIES</h2>

          <h3>3.1 Service Functionality</h3>
          <ul>
            <li>Maintain your login session</li>
            <li>Remember your preferences and settings</li>
            <li>Provide personalized content and recommendations</li>
          </ul>

          <h3>3.2 Analytics and Improvement</h3>
          <ul>
            <li>Understand user behavior and preferences</li>
            <li>Identify and fix technical issues</li>
            <li>Improve our Service based on usage patterns</li>
          </ul>

          <h3>3.3 Marketing and Communication</h3>
          <ul>
            <li>Deliver relevant content and updates</li>
            <li>Measure the effectiveness of our communications</li>
            <li>Personalize your experience</li>
          </ul>
        </section>

        <section>
          <h2>4. COOKIE MANAGEMENT</h2>

          <h3>4.1 Mobile App</h3>
          <ul>
            <li>
              Most cookies in our mobile app are essential for functionality
            </li>
            <li>
              You can manage some preferences through your device settings
            </li>
            <li>Clearing app data will remove stored cookies</li>
          </ul>

          <h3>4.2 Website</h3>
          <ul>
            <li>You can control cookies through your browser settings</li>
            <li>
              Most browsers allow you to refuse cookies or delete existing ones
            </li>
            <li>Blocking cookies may affect website functionality</li>
          </ul>
        </section>

        <section>
          <h2>5. THIRD-PARTY COOKIES</h2>
          <p>
            We use various third-party services that may set their own cookies:
          </p>
          <ul>
            <li>
              <strong>Analytics Providers:</strong> For understanding user
              behavior
            </li>
            <li>
              <strong>Authentication Services:</strong> For secure login
            </li>
            <li>
              <strong>Payment Processors:</strong> For subscription management
            </li>
            <li>
              <strong>Support Services:</strong> For customer service
            </li>
          </ul>
        </section>

        <section>
          <h2>6. COOKIE RETENTION</h2>
          <ul>
            <li>
              <strong>Session Cookies:</strong> Deleted when you close the app
              or browser
            </li>
            <li>
              <strong>Persistent Cookies:</strong> Remain for a set period or
              until manually deleted
            </li>
            <li>
              <strong>Analytics Cookies:</strong> Typically retained for 1-2
              years
            </li>
            <li>
              <strong>Preference Cookies:</strong> Retained until you change
              your settings
            </li>
          </ul>
        </section>

        <section>
          <h2>7. UPDATES TO THIS POLICY</h2>
          <p>
            We may update this Cookie Policy from time to time. We will notify
            you of any significant changes by posting the updated policy on our
            website.
          </p>
        </section>

        <section>
          <h2>8. CONTACT US</h2>
          <p>
            If you have questions about our use of cookies, please contact us:
          </p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Website:</strong> https://viralzapp.com/cookies
            </li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .legal-page {
          min-height: 100vh;
          background: #000000;
          color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
          padding: 0;
        }

        .legal-nav {
          background: rgba(0, 0, 0, 0.95);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(254, 44, 85, 0.2);
          padding: 20px 0;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .legal-nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .back-button {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #ffffff;
          text-decoration: none;
          font-weight: 600;
          font-size: 1rem;
          padding: 10px 16px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .back-button:hover {
          background: rgba(254, 44, 85, 0.2);
          border-color: #fe2c55;
          color: #fe2c55;
          transform: translateX(-2px);
        }

        .legal-nav-brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .legal-nav-logo {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: rgba(254, 44, 85, 0.1);
          padding: 4px;
          border: 1px solid rgba(254, 44, 85, 0.3);
        }

        .legal-nav-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #fe2c55;
        }

        .legal-container {
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.6;
          padding: 40px 20px;
        }

        h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 20px;
          background: linear-gradient(135deg, #fe2c55, #ff6b9d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .legal-meta {
          margin-bottom: 40px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
          border: 1px solid rgba(254, 44, 85, 0.2);
        }

        .legal-meta p {
          margin: 5px 0;
          color: #cccccc;
        }

        section {
          margin-bottom: 40px;
        }

        h2 {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #fe2c55;
        }

        h3 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #ffffff;
        }

        p {
          margin-bottom: 15px;
          color: #cccccc;
        }

        ul {
          margin-bottom: 20px;
          padding-left: 20px;
        }

        li {
          margin-bottom: 10px;
          color: #cccccc;
        }

        strong {
          color: #ffffff;
        }

        @media (max-width: 768px) {
          .legal-container {
            padding: 20px 15px;
          }

          .legal-nav-container {
            padding: 0 15px;
          }

          .legal-nav-title {
            font-size: 1.3rem;
          }

          .legal-nav-logo {
            width: 28px;
            height: 28px;
          }

          .back-button {
            padding: 8px 12px;
            font-size: 0.9rem;
          }

          h1 {
            font-size: 2rem;
          }

          h2 {
            font-size: 1.5rem;
          }

          h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CookiePolicy;
